<template>
  <div>
    <div style="margin:15px">
      <el-button
        :disabled="selectRow.length==1?false:true"
        icon="el-icon-edit"
        @click="openBox('edit')">编辑</el-button>
      <el-button
        :disabled="selectRow.length==1?false:true"
        icon="el-icon-edit"
        @click="getFamily()">查看家庭成员</el-button>
      <el-button
        icon="el-icon-edit"
        @click="getTableData()">查看帮扶对象</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" max-height="550" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" align="center" :width="x.type===3?'100px':''" :fixed="i<=7" :label="x.value"></el-table-column>
      </el-table>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="帮扶对象列表管理"
      :visible.sync="centerDialogVisible"
      :modal="false"
      @close="close"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">贫困户信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="户籍地址：">
                          <Area :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="自然村：">
                          <el-input style="width:193px;" v-model="editForm.natureVillage"></el-input>
                        </el-form-item>
                        <el-form-item label="户编号：">
                          <el-input style="width:193px;" v-model="editForm.residenceNo"></el-input>
                        </el-form-item>
                        <el-form-item label="人编号：">
                          <el-input style="width:193px;" v-model="editForm.personNo"></el-input>
                        </el-form-item>
                        <el-form-item prop="name" label="姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="证件号码：">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="人数：">
                          <el-input style="width:193px;" v-model="editForm.persons"></el-input>
                        </el-form-item>
                        <el-form-item label="与户主关系：">
                          <el-select size="mini" filterable v-model="editForm.relationShip" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.yuhuzhuguanxi" :key="i" :label="x" :value="x"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="民族：">
                          <el-select size="mini" filterable v-model="editForm.nation" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.nation" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="文化程度：">
                          <el-select size="mini" filterable v-model="editForm.education" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.wenHuaCD" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="务工时间(月)：">
                          <el-input style="width:193px;" v-model="editForm.workDuration"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="参加大病医疗：">
                          <el-select size="mini" filterable v-model="editForm.medical" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.options" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="在校生状况：">
                          <el-select size="mini" filterable v-model="editForm.studentStatus" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.zaixiaoshengzhuangkuang" :key="i" :label="x" :value="x"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="致贫原因：">
                          <el-select size="mini" filterable v-model="editForm.poorReason" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.checkList2" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="健康状况：">
                          <el-select size="mini" filterable v-model="editForm.healthy" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.jiankangzhuangtai" :key="i" :label="x" :value="x"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="劳动技能：">
                          <el-select size="mini" filterable v-model="editForm.laborSkill" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.laoDongNL" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="务工状况：">
                          <el-select size="mini" v-model="editForm.workStatus" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.wugongzhuangkuang" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="危房户：">
                          <el-select size="mini" v-model="editForm.dangerPoor" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.options" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="是否解决饮用水安全：">
                          <el-select size="mini" v-model="editForm.safeWater" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.options" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="人均纯收入：">
                          <el-input style="width:193px;" v-model="editForm.salary"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="政治面貌：">
                              <el-select size="mini" v-model="editForm.dangerPoor" placeholder="请选择">
                                <el-option v-for="(x,i) in $public.zhengzhimianmao" :key="i" :label="x.label" :value="x.label"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="户籍类型：">
                              <el-select size="mini" v-model="editForm.residenceType" placeholder="请选择">
                                <el-option v-for="(x,i) in $public.hujileixing" :key="i" :label="x.label" :value="x.label"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="特殊困难群体人员：">
                              <el-select size="mini" v-model="editForm.type" placeholder="请选择">
                                <el-option v-for="(x,i) in $public.options" :key="i" :label="x.label" :value="x.label"></el-option>
                              </el-select>
                        </el-form-item>-->
                        <el-form-item label="脱贫属性：">
                          <el-select size="mini" filterable v-model="editForm.lostPoorInfo" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.tuopinzhuangtai" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="脱贫年度：">
                          <el-date-picker style="width:193px;" v-model="editForm.lostPoorYear" value-format="yyyy" type="year" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="首次识别时间：">
                          <el-input style="width:193px;" v-model="editForm.poorFirstDate"></el-input>
                        </el-form-item>
                        <el-form-item label="贫困人员识别时间：">
                          <el-input style="width:193px;" v-model="editForm.poorInfoDate"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="返贫人员：">
                          <el-select size="mini" v-model="editForm.returnPoor" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.options" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="脱贫方式：">
                          <el-select size="mini" filterable v-model="editForm.lostPoorStyle" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.checkList3" :key="i" :label="x.label" :value="x.label"></el-option>
                          </el-select>
                        </el-form-item>-->
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="edit-box" v-show="!isCreate">
          <div class="edit-item">
            <div class="edit-left">服务日志录入</div>
            <div class="edit-right" style="padding-top:0">
              <div class="info-box">
                <div class="info-input">
                  <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane v-for="(x,i) in log" :key="i" :label="x.value" :name="x.value">
                      <div class="log">
                        <div>
                          <label for="desc">服务内容：</label>
                          <div id="desc">
                            <el-input type="textarea" v-model="serviceContent" :rows="3"></el-input>
                          </div>
                          <label for="res">服务结果：</label>
                          <div id="res">
                            <el-input type="textarea" v-model="serviceResult" :rows="3"></el-input>
                          </div>
                        </div>
                        <div>
                          <label for="img">上传图片：</label>
                          <div style="width:100%;" id="img">
                            <el-upload
                              :limit="3"
                              ref="uploadImg"
                              :file-list="fileList"
                              :class="{disabled:isMax}"
                              :on-error="error"
                              :action="uploadUrl"
                              :on-success="imgAdd"
                              :on-change="change"
                              list-type="picture-card"
                              :on-preview="handlePictureCardPreview"
                              :on-remove="handleRemove">
                              <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                            />
                            </el-dialog>
                          </div>
                          <div style="margin:10px 10px 0 0;float:right;">
                            <el-button type="primary" v-show="!isCreate" @click="submitLog()">提交日志</el-button>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="edit-box" v-show="!isCreate">
          <div class="edit-item">
            <div class="edit-left">服务记录查询</div>
            <div class="edit-right" style="padding-top:0;flex: 0 0 95%;">
              <div class="info-box">
                <div class="info-input">
                  <el-table :data="logData" max-height="500" border style="width: 99.9%">
                    <el-table-column
                      show-overflow-tooltip v-for="(x,i) in $public.info" :key="i"
                      :prop="x.key" :label="x.value" align="center"></el-table-column>
                    <el-table-column label="图片" type="expand">
                      <template slot-scope="props">
                        <div v-if="props.row.fileIds === ''?false:true">
                          <span v-for="(x,i) in props.row.fileIds" :key="i" style="margin-left:10px">
                            <el-image style="width: 100px; height: 100px" :src="x" :preview-src-list="props.row.fileIds"></el-image>
                          </span>
                        </div>
                        <div v-else>
                          <span>无详情图片</span>
                        </div>
                        <div class="content">
                          <h3>服务内容：</h3>
                          <p>{{props.row.serviceContent}}</p>
                        </div>
                        <div class="content">
                          <h3>服务结果：</h3>
                          <p>{{props.row.serviceResult}}</p>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <paging :pagesData="paging" @set_page_number="get_page"></paging>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return {
      uploadUrl: `${this.$api.imgUrl}/user/img/upload`,
      api: "/user/poorInfo",
      form: {},
      centerDialogVisible: false,
      tableData: [],
      selectRow: [],
      baseInfo: [
        { key: "province", value: "省" },
        { key: "city", value: "市" },
        { key: "county", value: "县" },
        { key: "town", value: "镇" },
        { key: "village", value: "村" },
        { key: "natureVillage", value: "自然村" },
        { key: "residenceNo", value: "户编号" },
        { key: "personNo", value: "人编号" },
        { key: "name", value: "姓名" },
        { key: "idCard", value: "证件号码" },
        { key: "persons", value: "人数" },
        { key: "relationShip", value: "与户主关系" },
        { key: "nation", value: "民族" },
        { key: "education", value: "文化程度" },
        { key: "studentStatus", value: "在校生状况" },
        { key: "healthy", value: "健康状况" },
        { key: "laborSkill", value: "劳动技能" },
        { key: "workStatus", value: "务工状况" },
        { key: "workDuration", value: "务工时间（月）" },
        { key: "medical", value: "参加大病医疗" },
        { key: "lostPoorInfo", value: "脱贫属性" },
        { key: "lostPoorYear", value: "脱贫年度" },
        { key: "poorInfo", value: "贫困户属性" },
        { key: "poorReason", value: "致贫原因1" },
        { key: "dangerPoor", value: "危房户" },
        { key: "safeWater", value: "是否解决安全饮用水" },
        { key: "salary", value: "人均纯收入" },
        { key: "phone", value: "联系电话" },
        // {key:'politics',value:'政治面貌'},
        // {key:'residenceType',value:'户籍类型'},
        // {key:'difficultPerson',value:'特殊困难群体人员'},
        // {key:'lostPoorStyle',value:'脱贫方式'},
        // {key:'returnPoor',value:'返贫人员'},
        { key: "poorFirstDate", value: "首次识别时间" },
        { key: "poorInfoDate", value: "贫困人员识别时间" }
      ],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { min: 18, max: 18, message: "长度为18个字符", trigger: "blur" }
        ],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }]
      },
      isCreate: false,
      log: [
        { value: "结对帮扶", key: 0 },
        { value: "信息采集", key: 1 },
        { value: "就业服务", key: 2 },
        { value: "培训服务", key: 3 },
        { value: "创业服务", key: 4 },
        { value: "维权服务", key: 5 },
        { value: "其它服务", key: 6 }
      ],
      imageUrl: "",
      logType: 1,
      activeName: "结对帮扶",
      logImg: [],
      serviceContent: "",
      serviceResult: "",
      fileList: [],
      isMax: false,
      dialogVisible: false,
      paging: {
        currentPage: 1,
        pageSize: 50,
        total: 0
      },
      logData: [],
      page: 1,
      imageUrl1: "",
      headImgId: ""
    }
  },
  created() {
    this.getArea({ value: { areaId: 0 }, key: 0 })
    this.getTableData()
  },
  methods: {
    //选取行
    handleSelectionChange(val) {
      console.log(val)
      this.selectRow = val
      if (val.length > 0) {
        this.getData(this.page, val[0].id)
        this.imageUrl1 = `${this.$api.imgUrl}/user/img/${val[0].imgId}`
      }
    },
    //查询
    getTableData() {
      this.$api.getSelfHelp().then(res => {
        res.data.status === 0
          ? (this.tableData = JSON.parse(res.data.data))
          : this._status(res.data)
      })
    },
    //查看家庭成员
    getFamily() {
      this.$api.family(this.selectRow[0].residenceNo).then(res =>{
        res.data.status == 0 ? this.tableData = JSON.parse(res.data.data):this._status(res.data)
        
      })
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.editForm.pageNumber = pageNumer
      vm.Filter_file({
        api: vm.api,
        data: vm.form,
        callback: _d => (vm.tableData = _d)
      })
    },
    //提交请求
    submit() {
      let newForm = {}
      // console.log(this.province,this.city,this.county)
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.graduationTime = new Date(newForm.graduationTime).getTime()
      newForm.trainingTime = new Date(newForm.trainingTime).getTime()
      newForm.trainingWishTime = new Date(newForm.trainingWishTime).getTime()
      newForm.workTime = new Date(newForm.workTime).getTime()
      newForm.helpTime = new Date(newForm.helpTime).getTime()
      newForm.lostJobTime = new Date(newForm.lostJobTime).getTime()
      newForm.jobWishTime = new Date(newForm.jobWishTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      newForm.imgId = this.headImgId
      this.$refs["editForm"].validate(valid => {
        if (valid && this.isCreate === true) {
          this.$api.create(this.api, newForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success("创建成功!")
              this.getTableData()
            } else{
              this._status(res.data)
            }
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`, newForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success("修改成功!")
              this.getTableData()
            } else{
              this._status(res.data)
            }
          })
        } else {
          return false
        }
      })
    },
    //头像
    handleAvatarSuccess1(res, file) {
      this.$message.success("上传成功！")
      this.imageUrl1 = URL.createObjectURL(file.raw)
      console.log(res)
      this.headImgId = res.data
    },
    beforeAvatarUpload1(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "png"
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、PNG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!")
      }
      return isJPG && isLt2M
    },
    //图片移除
    handleRemove(file, fileList) {
      this.fileList = fileList
      if (fileList.length < 3) {
        this.isMax = false
      }
    },
    //图片预览
    handlePictureCardPreview(file) {
      this.imageUrl = file.url
      this.dialogVisible = true
    },
    //图片状态改变时触发
    change(file, fileList) {
      if (fileList.length >= 3) {
        this.isMax = true
      }
    },
    //图片上传成功回调
    imgAdd(response, file, fileList) {
      this.fileList = fileList
      // this.$refs['uploadImg'].clearFiles()
    },
    //图片上传失败
    error(err, file, fileList) {
      this.$message.error("上传失败")
      if (fileList.length >= 3) {
        this.isMax = true
      } else {
        this.isMax = false
      }
    },
    //类型选择
    handleClick(tab, event) {
      this.logImg = []
      this.logType = parseInt(tab.index) + 1
    },
    //提交日志请求
    submitLog() {
      if (this.serviceContent === "") {
        return this.$message.info("请输入服务内容")
      } else if (this.serviceResult === "") {
        return this.$message.info("请输入服务结果")
      } else {
        this.fileList.forEach(element => {
          this.logImg.push(element.response.data)
        })
        let logData = {
          operateLogType: this.logType,
          targetId: this.selectRow[0].id,
          fileIds: this.logImg.join(','),
          serviceContent: this.serviceContent,
          serviceResult: this.serviceResult
        }
        this.$api.createLog(logData).then(res => {
          if (res.data.status === 0) {
            this.$message.success("提交日志成功！")
            this.getData(this.page, this.selectRow[0].id)
            this.$refs.uploadImg.forEach(element => {
              element.clearFiles()
            })
            this.serviceResult = this.serviceContent = ""
          } else{
            this._status(res.data)
          }
        })
      }
    },
    //日志分页
    get_page(pageNumer) {
      this.getData(pageNumer,this.selectRow[0].id)
    },
    //对象日志记录查询
    getData(page, id) {
      let vm = this
      vm.$api.getTargetLog({ pageNumber: page, targetId: id }).then(res => {
        if (res.data.status === 0) {
          vm.paging.total = res.data.size
          vm.paging.pageSize = res.data.pageSize
          vm.logData = JSON.parse(res.data.data)
          vm.logData.forEach(element => {
            element.operateLogType =
              vm.$public.type[element.operateLogType - 1]
            if (element.fileIds === "") {
            } else {
              element.fileIds = element.fileIds.split(",")
              element.fileIds.forEach((item, index) => {
                element.fileIds[index] = vm.$api.imgUrl + "/user/img/" + item
              })
            }
          })
        } else {
          this._status(res.data)
        }
      })
    }
  }
}
</script>

<style>
.el-textarea .el-textarea__inner {
  resize: none;
}
.log {
  display: flex;
  flex-direction: row;
}
.log > div {
  flex: 1 1 40%;
  margin-left: 20px;
}
.log .disabled .el-upload--picture-card {
  display: none;
}
.info-input .el-tabs--border-card > .el-tabs__content {
  padding: 10px 0 10px 0 !important;
}

.content {
  width: 100%;
  word-wrap: break-word;
  word-break: normal;
}
.head-img {
  height: 178px;
  width: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 178px;
  display: block;
}
</style>